import type React from 'react';
import SvgIcon from './SvgIcon';

const RightLeft: React.FC = () => (
  <SvgIcon
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
  >
    <g id="RightLeft">
      <path d="M6.70703 12.707L3.91406 15.5H17V17.5H3.91406L6.70703 20.293L5.29297 21.707L0.792969 17.207C0.605435 17.0195 0.5 16.7652 0.5 16.5C0.500002 16.2679 0.580726 16.0442 0.726562 15.8662L0.792969 15.793L5.29297 11.293L6.70703 12.707Z" fill="currentColor" />
      <path d="M17.207 4.79297L17.2734 4.86621C17.4192 5.04414 17.5 5.26798 17.5 5.5C17.5 5.76513 17.3945 6.01951 17.207 6.20703L12.707 10.707L11.293 9.29297L14.0859 6.5H1V4.5H14.0859L11.293 1.70703L12.707 0.292969L17.207 4.79297Z" fill="currentColor" />
    </g>
  </SvgIcon>
);

export default RightLeft;
